import { createNavigationContainerRef } from '@react-navigation/native';

// Global ref so non-screen components (and independent navigators) can still
// navigate the app's root stack (e.g. to logout/map/mymissions).
// NOTE: the app doesn't define a typed RootParamList yet, so use `any` to allow
// navigation by route name from non-screen components.
export const rootNavigationRef = createNavigationContainerRef<any>();

export const rootNavigate = (name: string, params?: any) => {
  if (!rootNavigationRef.isReady()) return;
  rootNavigationRef.navigate(name, params);
};
